import type { Messages } from './en';

/** Finnish UI messages. Prototype draft: needs native-speaker review before any pilot (PROJECT_STATUS K15). */
export const fi: Messages = {
  'shell.skipLink': 'Siirry sisältöön',
  'shell.brand': 'Kids World',
  'shell.brandTag': 'Prototyyppi',
  'shell.navLabel': 'Päävalikko',
  'shell.menu': 'Valikko',
  'shell.closeMenu': 'Sulje valikko',
  'shell.broadcaster': 'Yleisradioyhtiö',
  'shell.language': 'Kieli',
  'shell.help': 'Ohje',
  'shell.disclaimer':
    'Kids World on alustava konseptiprototyyppi. Kaikki näytetyt yleisradioyhtiöt, ohjelmat ja henkilöt ovat kuvitteellisia. Se ei ole EBU:n tai sen jäsenten palvelu eikä viittaa niiden tukeen.',
  'shell.helpAndData': 'Ohje ja tietosi',
  'shell.loading': 'Ladataan…',

  'nav.discover': 'Kaupunki',
  'nav.watch': 'Katso',
  'nav.play': 'Pelaa',
  'nav.create': 'Luo',
  'nav.projects': 'Omat projektit',
  'nav.skills': 'Omat taidot',

  'error.retry': 'Yritä uudelleen',
  'error.code': 'Virhe {code}.',
  'error.WEB-NAV-001': 'Sivua ei löytynyt. Palaa Tutki-sivulle jatkamaan.',
  'notFound.title': 'Sivua ei löytynyt',
  'notFound.back': 'Takaisin alkuun',
  'error.generic': 'Jokin meni meidän päässämme vikaan. Yritä hetken päästä uudelleen.',
  'error.WEB-API-001': 'Kids Worldiin ei saada nyt yhteyttä. Tarkista yhteys ja yritä uudelleen.',
  'error.API-DB-001': 'Ohjelmia ei voi nyt ladata. Yritä hetken päästä uudelleen.',
  'error.API-RATE-001': 'Liian monta pyyntöä kerralla. Odota hetki ja yritä uudelleen.',
  'error.CONTENT-CONFIG-001': 'Yleisradioyhtiötä ei löytynyt. Valitse luettelosta toinen.',
  'error.CONTENT-CATALOGUE-001':
    'Tätä ohjelmaa ei ole valitsemasi yhtiön luettelossa. Valitse luettelosta toinen ohjelma.',
  'error.WEB-STORAGE-001':
    'Tämä selain ei voi nyt tallentaa mitään. Voit silti katsoa ja tutkia; valintasi säilyvät, kunnes suljet sivun.',

  'discover.title': 'Tutki',
  'discover.intro': 'Katso ohjelmia, pelaa ja tee itse — kirjautumista ei tarvita.',
  'discover.startExploring': 'Aloita tutkiminen',
  'discover.featured': 'Nostanut esiin: {broadcaster}',
  'discover.watch': 'Katso',
  'discover.noItems': 'Tällä yhtiöllä ei ole nyt ohjelmia luettelossa.',
  'rail.fromBroadcasters': 'Yleisradioyhtiöiltämme',
  'rail.fromBroadcastersNote': 'Yhtiön {broadcaster} toimittajien valitsemat ja järjestämät.',
  'rail.playWithStory': 'Pelaa tarinan kanssa',
  'rail.playWithStoryNote': 'Ohjelmia, joihin kuuluu peli.',
  'rail.makeSomething': 'Tee jotain',
  'rail.makeSomethingNote': 'Ohjelmia rakentamisesta, tekemisestä ja kokeilemisesta.',
  'rail.empty': 'Tällä yhtiöllä ei ole täällä vielä mitään.',
  'rail.previous': 'Näytä edelliset ohjelmat',
  'rail.next': 'Näytä lisää ohjelmia',
  'rail.seeAll': 'Kaikki ohjelmat',

  'data.title': 'Tietosi tässä laitteessa',
  'data.body':
    'Kids Worldia voi käyttää ilman tiliä. Valintasi (yhtiö, kieli ja halutessasi kiinnostuksen kohteet) sekä kaikki, mitä teet, tallennetaan vain tähän selaimeen. Meille ei lähetetä mitään.',
  'data.warning':
    'Selaimet voivat poistaa tallennettuja tietoja, esimerkiksi yksityisessä selauksessa tai kun sivuston tiedot tyhjennetään. Vie talteen projektit, jotka haluat säilyttää.',
  'data.nothingSaved': 'Tähän selaimeen ei ole vielä tallennettu mitään.',
  'data.savedChoices': 'Valintasi on tallennettu tähän selaimeen.',
  'data.projects.one': '{count} tallennettu projekti',
  'data.projects.other': '{count} tallennettua projektia',
  'data.clear': 'Poista tietoni',
  'data.clearTitle': 'Poistetaanko tietosi tästä selaimesta?',
  'data.clearBody':
    'Tämä poistaa tallennetut valintasi, projektisi ja edistymisesi tästä selaimesta. Vie ensin talteen projektit, jotka haluat säilyttää. Toimintoa ei voi perua.',
  'data.cancel': 'Peruuta',
  'data.cleared': 'Tietosi on poistettu tästä selaimesta.',

  'card.ages': 'Ikä {min}–{max}',
  'card.minutes': 'Noin {minutes} min',
  'card.episode': 'Kausi {season}, jakso {episode}',
  'card.audio': 'Ääni: {languages}',
  'card.captions': 'Tekstitys: {languages}',
  'card.noCaptions': 'Ei vielä tekstitystä',
  'card.origin': 'Tekijä: {origin}',
  'card.game': 'Sisältää pelin',
  'card.fictional': 'Kuvitteellinen esimerkki',
  'card.textLanguage': 'Teksti: {language}',
  'availability.playable': 'Valmis katsottavaksi',
  'availability.media-missing': 'Video ei ole vielä saatavilla',
  'availability.not-streamable': 'Vain luettelossa, ei katsottavissa täällä',
  'availability.rights-not-started': 'Saatavilla {date} alkaen',

  'format.episode': 'Jakso',
  'format.short': 'Lyhytelokuva',
  'format.special': 'Erikoisohjelma',
  'format.clip': 'Klippi',
  'topic.science': 'Tiede',
  'topic.nature': 'Luonto',
  'topic.stories': 'Tarinat',
  'topic.making': 'Tekeminen',
  'topic.music': 'Musiikki',
  'topic.sport': 'Urheilu',
  'topic.history': 'Historia',
  'topic.animals': 'Eläimet',
  'warning.mild-peril': 'Lievää jännitystä',
  'warning.loud-noises': 'Kovia ääniä',
  'warning.flashing-lights': 'Vilkkuvia valoja',
  'warning.darkness': 'Pimeitä kohtauksia',
  'credit.production': 'Tuotanto',
  'credit.commissioning-member': 'Tilaajajäsen',
  'credit.creator-collaboration': 'Sisällöntuottajayhteistyö',
  'credit.voice': 'Ääni',
  'credit.music': 'Musiikki',

  'watch.title': 'Katso',
  'watch.intro': 'Kaikki yhtiön {broadcaster} ohjelmat toimittajien valitsemassa järjestyksessä.',
  'filter.legend': 'Etsi ohjelma',
  'filter.search': 'Haku',
  'filter.searchHint': 'Sanoja nimestä tai kuvauksesta',
  'filter.topics': 'Kiinnostuksen kohteet',
  'filter.age': 'Ikä',
  'filter.ageAny': 'Kaikki iät',
  'filter.format': 'Tyyppi',
  'filter.formatAny': 'Kaikki tyypit',
  'filter.clear': 'Tyhjennä suodattimet',
  'filter.remember': 'Muista kiinnostuksen kohteeni tässä selaimessa',
  'filter.rememberHint':
    'Vapaaehtoinen. Tallennetaan vain tähän laitteeseen eikä lähetetä minnekään.',
  'watch.results.one': '{count} ohjelma',
  'watch.results.other': '{count} ohjelmaa',
  'watch.noResults': 'Näillä valinnoilla ei löytynyt ohjelmia.',
  'watch.noResultsHint': 'Kokeile vähemmän kiinnostuksen kohteita, toista ikää tai eri sanoja.',

  'programme.back': 'Kaikki ohjelmat',
  'programme.details': 'Tiedot',
  'programme.made': 'Tekijä',
  'programme.credits': 'Tekijät',
  'programme.goodToKnow': 'Hyvä tietää',
  'programme.languages': 'Kielet',
  'programme.series': 'Sarjan jaksot',
  'programme.thisEpisode': 'Tämä jakso',
  'programme.playable': 'Tämän ohjelman saa näyttää täällä.',
  'programme.unavailable.media-missing':
    'Tämän ohjelman video ei ole vielä saatavilla. Voit lukea siitä ja tutkia muita ohjelmia.',
  'programme.unavailable.not-streamable':
    'Ohjelma voi näkyä luettelossa, mutta sitä ei voi katsoa Kids Worldissa.',
  'programme.unavailable.rights-not-started': 'Tämän ohjelman voi katsoa {date} alkaen.',
  'programme.whatNext': 'Mitä seuraavaksi?',
  'programme.moreProgrammes': 'Tutki lisää ohjelmia',
  'programme.backToDiscover': 'Takaisin kaupunkiin',

  'place.cinema': 'Elokuvateatteri',
  'place.cinemaNote': 'Katso toimittajien valitsemia ohjelmia.',
  'place.lab': 'Löytölabra',
  'place.labNote': 'Ratkaise tarinoihimme liittyviä virtapiiritehtäviä.',
  'place.tower': 'Euroopan maapallo',
  'place.towerNote': 'Valitse yhtiö ja kieli.',
  'place.workshop': 'Tekijöiden piha',
  'place.workshopNote': 'Rakenna asioita 3D:nä.',
  'place.treehouse': 'Puumaja',
  'place.treehouseNote': 'Omat projektisi ja taitosi, tallennettu tähän selaimeen.',
  'hub.title': 'Kids World -kaupunki',
  'hub.welcomeTitle': 'Tervetuloa Kids Worldiin',
  'hub.welcomeBody':
    'Tutki kaupunkia. Elokuvateatterissa voit katsoa ohjelmia, labrassa ratkaista virtapiiritehtäviä, tekijöiden pihalla rakentaa ja Euroopan maapallolla valita yhtiön; puumajassa näet projektisi ja taitosi. Kirjautumista ei tarvita.',
  'hub.startExploring': 'Aloita tutkiminen',
  'hub.placesLabel': 'Paikat kaupungissa',
  'hub.goIn': 'Mene sisään',
  'hub.lookInside': 'Kurkista',
  'hub.building': 'Rakenteilla',
  'hub.keysHint': 'Nuolinäppäimet valitsevat paikan. Enter vie sisään.',
  'hub.previousPlace': 'Edellinen paikka',
  'hub.nextPlace': 'Seuraava paikka',
  'hub.nowShowing': 'Nyt ohjelmistossa',
  'hub.loading3d': 'Kaupunkia rakennetaan…',
  'hub.useMap': 'Yksinkertainen kartta',
  'hub.use3d': '3D-kaupunki',
  'hub.mapTitle': 'Kaupungin kartta',
  'error.WORLD-RENDER-001':
    'Selaimesi ei voi näyttää 3D-kaupunkia. Yksinkertainen kartta toimii samalla tavalla.',
  'poster.sample': 'Kuvitteellinen esimerkki',
  'data.close': 'Sulje',
  'data.open': 'Omat tiedot',
  'cinema.title': 'Elokuvateatteri',
  'cinema.back': 'Takaisin kaupunkiin',
  'cinema.interests': 'Mistä pidät?',
  'cinema.everything': 'Kaikki',
  'cinema.allAges': 'Kaikki iät',
  'cinema.allTypes': 'Kaikki tyypit',
  'cinema.shelfAll': 'Kaikki ohjelmat',
  'cinema.shelfGames': 'Tarinoita ja peli',
  'cinema.shelfMaking': 'Tee ja rakenna',
  'cinema.results': 'Ohjelmia sinulle',
  'tower.title': 'Euroopan maapallo',
  'tower.intro':
    'Jokainen yhtiö valitsee ohjelmat omaan maahansa. Tallennetut asiasi säilyvät, kun vaihdat.',
  'tower.choose': 'Valitse yhtiö',
  'tower.selected': 'Valittu',
  'tower.languages': 'Kielet',
  'hub.canvasLabel':
    '3D-kaupunki. Kävele näppäimillä W A S D tai nuolilla, katsele vetämällä ja paina ovella Enter mennäksesi sisään.',
  'hub.pressEnter': 'Olet ovella. Paina Enter mennäksesi sisään.',
  'hub.walkHint': 'W A S D tai nuolet kävelyyn · vedä katsellaksesi · vieritä zoomataksesi',
  'player.label': 'Videosoitin',
  'player.play': 'Toista',
  'player.start': 'Toista ohjelma',
  'player.pause': 'Tauko',
  'player.back10': '10 sekuntia taaksepäin',
  'player.forward10': '10 sekuntia eteenpäin',
  'player.mute': 'Mykistä',
  'player.unmute': 'Ääni päälle',
  'player.volume': 'Äänenvoimakkuus',
  'player.seek': 'Kohta ohjelmassa',
  'player.time': '{current} / {total}',
  'player.captions': 'Tekstitys',
  'player.captionsOff': 'Pois',
  'player.fullscreen': 'Koko näyttö',
  'player.exitFullscreen': 'Poistu koko näytöstä',
  'player.keys':
    'Näppäimet: välilyönti toista tai tauko · ← → 5 sekuntia · ↑ ↓ äänenvoimakkuus · M mykistä · C tekstitys · F koko näyttö',
  'player.loading': 'Video latautuu…',
  'player.watchAgain': 'Katso uudelleen',
  'player.captionsFailed': 'Tekstitystä ei voitu ladata.',
  'player.retry': 'Yritä uudelleen',
  'end.title': 'Loppu. Mitä seuraavaksi?',
  'end.body': 'Voit lopettaa tähän tai valita, mitä teet seuraavaksi.',
  'programme.nextGame': 'Seuraavaksi: kokeile virtapiiritehtävää',
  'programme.createWorkshop': 'Luo pajassa',
  'programme.playGame': 'Pelaa peliä',
  'card.noSpeech': 'Ei puhetta: musiikkia ja ääniä',
  'error.CONTENT-MEDIA-002':
    'Videota ei voitu toistaa. Yritä uudelleen tai valitse sen sijaan peli tai paja.',
  'shell.fictionalBar':
    'Prototyyppi · kaikki lähettäjät, ohjelmat ja henkilöt ovat kuvitteellisia · ei EBU:n tai sen jäsenen palvelu',
  'shell.searchHint': 'Hae ohjelmia',
  'nav.cinema': 'Elokuvateatteri',
  'nav.lab': 'Laboratorio',
  'nav.workshop': 'Paja',
  'nav.myStuff': 'Omat jutut',
  'cinema.featured': 'Nostossa',
  'cinema.featuredGame': 'Nostossa · mukana peli',
  'cinema.watchNow': 'Katso nyt',
  'cinema.tryChallenge': 'Kokeile tehtävää',
  'cinema.aboutIt': 'Lisätietoja',
  'cinema.rowAll': 'Kaikki ohjelmat: {broadcaster}',
  'cinema.rowAllNote': 'Toimittajien valitsemassa järjestyksessä',
  'cinema.rowGames': 'Katso ja pelaa',
  'cinema.rowGamesNote': 'Tarinoita, joihin liittyy tehtävä laboratoriossa',
  'cinema.rowMaking': 'Tee ja rakenna',
  'cinema.rowMakingNote': 'Ohjelmia rakentamisesta, tekemisestä ja kokeilemisesta',
  'cinema.rowLiked': 'Koska pidät aiheista {topics}',
  'cinema.rowLikedNote': 'Tähän laitteeseen tallentamiesi kiinnostuksen kohteiden perusteella',
  'cinema.showAll': 'Näytä kaikki',
  'search.title': 'Ohjelmat',
  'search.resultsFor': 'Tulokset: ”{query}”',
  'search.filters': 'Suodattimet',
  'search.topics': 'Kiinnostuksen kohteet',
  'card.thumbFictional': 'Kuvitteellinen',
  'programme.crumbs': 'Sijainti',
  'programme.side': 'Jaksot ja tekemistä',
  'programme.seasonTitle': 'Kausi {season}',
  'programme.itemVideo': 'Video · {duration}',
  'programme.watchingNow': 'Katsot nyt',
  'programme.challengeItem': 'Tehtävä: {title}',
  'programme.challengeMeta': 'Peli laboratoriossa',
  'programme.buildItem': 'Rakenna jotain pajassa',
  'programme.buildMeta': 'Paja',
  'programme.stopAnyTime': 'Voit lopettaa milloin tahansa. Seuraava jakso ei ala itsestään.',
  'programme.tabOverview': 'Yleiskatsaus',
  'programme.tabLanguages': 'Kielet',
  'programme.tabAbout': 'Tietoja',
  'programme.learn': 'Mitä opit',
  'objective.closedLoop': 'Lamppu palaa vain, kun virtapiiri on suljettu',
  'objective.switchControl': 'Kytkin avaa ja sulkee virtapiirin',
  'objective.faultDiagnosis': 'Miten rikkinäisen virtapiirin aukko löydetään',
  'objective.sensorLogic': 'Miten valo voi syttyä itsestään, kun tulee pimeää',
  'game.lab.title': 'Löytölabra',
  'game.lab.intro':
    'Ratkaise tarinoihimme liittyviä virtapiiritehtäviä. Yhdistä paristoja, kytkimiä ja lamppuja. Aikaa ei mitata eikä pisteitä anneta.',
  'game.lab.none': 'Tehtäviä ei ole vielä julkaistu.',
  'game.lab.start': 'Aloita',
  'game.lab.challenges.one': '{count} tehtävä',
  'game.lab.challenges.other': '{count} tehtävää',
  'game.loading': 'Tehtävä latautuu…',
  'game.backToLab': 'Takaisin labraan',
  'game.part.battery': 'Paristo',
  'game.part.lamp': 'Lamppu',
  'game.part.switch': 'Kytkin',
  'game.part.light-sensor': 'Valoanturi',
  'game.end.plus': '+ -pää',
  'game.end.minus': '− -pää',
  'game.end.left': 'vasen pää',
  'game.end.right': 'oikea pää',
  'game.terminal': '{part}, {end}',
  'game.find.short-circuit':
    'Oikosulku! Johto kulkee +:sta −:aan ilman lamppua välissä, joten paristo kuumenisi. Poista se johto.',
  'game.find.battery-unconnected': 'Paristoa ei ole vielä yhdistetty mihinkään.',
  'game.find.gap': 'Silmukassa on aukko. Mihinkään ei ole yhdistetty: {ends}.',
  'game.find.lamp-bypassed':
    'Johto yhdistää lampun {lamp} molemmat päät, joten sähkö kulkee lampun ohi eikä sen läpi.',
  'game.find.switch-open': '{switches} on pois päältä, joten silmukka on auki.',
  'game.find.sensor-off': 'On päivä, joten valoanturi ei päästä sähköä läpi.',
  'game.find.hidden-fault':
    'Kaikki näyttää yhdistetyltä, mutta jokin silmukassa ei päästä sähköä läpi.',
  'game.find.hidden-fault-tester':
    'Kaikki näyttää yhdistetyltä, mutta jokin silmukassa ei päästä sähköä läpi. Etsi se testerillä.',
  'game.find.dim':
    '{lamp} palaa vain himmeästi: se jakaa pariston toisen lampun kanssa samassa silmukassa.',
  'game.find.not-controlled-switch':
    '{lamp} palaa, vaikka kytkin on pois päältä: kytkin ei ole sen silmukassa.',
  'game.find.not-controlled-sensor':
    '{lamp} palaa päivänvalossa: valoanturi ei ole sen silmukassa.',
  'game.find.unknown': 'Ei vielä ihan. Katso lamppuja ja yritä uudelleen.',
  'game.cond.night': 'yöllä',
  'game.cond.day': 'päivällä',
  'game.cond.switchOn': 'kun {switch} on päällä',
  'game.cond.switchOff': 'kun {switch} on pois päältä',
  'game.cond.lead': '(Testattu {conditions}.)',
  'game.refused.same-terminal': 'Valitse eri pää.',
  'game.refused.already-connected': 'Nuo kaksi päätä on jo yhdistetty.',
  'game.refused.no-wires-left':
    'Laatikossa ei ole enää johtoja. Poista johto käyttääksesi sen uudelleen.',
  'game.connected': 'Johto yhdistetty: {from} – {to}.',
  'game.selected': '{terminal} valittu. Valitse nyt, mihin johto menee.',
  'game.cancelled': 'Johto peruttu.',
  'game.restarted': 'Lauta on taas alussa.',
  'game.on': 'päällä',
  'game.off': 'pois',
  'game.dim': 'himmeä',
  'game.lampStatus': '{lamp}: {state}',
  'game.boardHelp':
    'Valitse yksi pää ja sitten toinen yhdistääksesi ne johdolla (tai vedä niiden välillä). Esc peruu. Napsauta kytkintä kääntääksesi sen.',
  'game.shortWarning': 'Oikosulku! Paristo on yhdistetty suoraan +:sta −:aan.',
  'game.wiresLeft.one': 'Laatikossa on {count} johto',
  'game.wiresLeft.other': 'Laatikossa on {count} johtoa',
  'game.daylight': 'Päivä vai yö',
  'game.night': 'Yö',
  'game.day': 'Päivä',
  'game.connections': 'Johdot ja osat',
  'game.connectForm': 'Yhdistä kaksi päätä',
  'game.from': 'Mistä',
  'game.to': 'Mihin',
  'game.connect': 'Yhdistä',
  'game.noWires': 'Laudalla ei ole vielä johtoja.',
  'game.test.ok': 'Testeri piippaa: tämä toimii.',
  'game.test.broken': 'Ei piippausta: tämä on rikki!',
  'game.testWire': 'Testaa johto {wire}',
  'game.testLamp': 'Testaa: {lamp}',
  'game.testPart': 'Testaa',
  'game.removeWire': 'Poista johto {wire}',
  'game.removed': 'Johto poistettu: {wire}.',
  'game.remove': 'Poista',
  'game.parts': 'Osat',
  'game.lampReplaced': 'Uusi lamppu on paikallaan.',
  'game.replaceLamp': 'Uusi lamppu',
  'game.level': 'Taso {level}',
  'game.goal': 'Tavoitteesi',
  'game.test': 'Testaa virtapiiri',
  'game.success': 'Onnistuit!',
  'game.attempts.one': 'Ratkaistu {count} testillä.',
  'game.attempts.other': 'Ratkaistu {count} testillä.',
  'game.notYet': 'Ei vielä',
  'game.noMoreHints': 'Ei enempää vihjeitä',
  'game.hint': 'Näytä vihje',
  'game.startAgain': 'Aloita alusta',
  'game.easier': 'Kokeile helpompaa',
  'game.harder': 'Kokeile vaikeampaa',
  'game.challengeList': 'Tehtävät',
  'game.solvedMark': 'Tehty',
  'error.GAME-CIRCUIT-001': 'Tätä tehtävää ei voitu ladata. Kokeile toista tehtävää.',
  'error.GAME-MISSION-001': 'Tämä tehtävä ei ole saatavilla. Valitse toinen labrassa.',
  'learn.why': 'Miksi tämä tehtävä?',
  'learn.next': 'Seuraavaksi: {title}',
  'learn.reason.start': 'Tästä kaikki aloittavat.',
  'learn.reason.start-harder':
    'Kerroit tehneesi virtapiirejä ennenkin, joten aloitat askelta vaikeammasta.',
  'learn.reason.step-up':
    'Ratkaisit tehtävän ”{challenge}” itse, joten tässä on samasta ideasta vaikeampi.',
  'learn.reason.next-idea': 'On uuden idean aika.',
  'learn.reason.next-idea-help':
    '”{challenge}” vaati vähän apua, joten palaat siihen ideaan myöhemmin. Ensin uusi idea.',
  'learn.reason.fast-track':
    'Ratkaisit kaksi vaikeampaa tehtävää peräkkäin itse, joten tämä uusi idea alkaa vaikeammalta tasolta.',
  'learn.reason.step-down':
    '”{challenge}” ei ole vielä ratkaistu, joten tämä helpompi tehtävä samasta ideasta voi auttaa.',
  'learn.reason.try-again': '”{challenge}” ei ole vielä ratkaistu. Kokeile uudelleen!',
  'learn.reason.revisit': 'Takaisin ideaan, joka vaati aiemmin vähän apua.',
  'learn.reason.all-shown': 'Olet näyttänyt kaikki ideat itse. Valitse mikä tahansa tehtävä.',
  'learn.reason.your-choice': 'Valitsit tämän itse. Se on ihan hyvä!',
  'learn.obj.closed-loop': 'Suljetut silmukat',
  'learn.obj.switch-control': 'Kytkimet',
  'learn.obj.fault-diagnosis': 'Vikojen etsiminen',
  'learn.obj.sensor-logic': 'Valoanturi',
  'learn.status.unobserved': 'Ei vielä kokeiltu',
  'learn.status.emerging': 'Alussa',
  'learn.status.practised': 'Harjoiteltu',
  'learn.status.demonstrated': 'Näytetty itse',
  'learn.savePrompt.title': 'Muistetaanko edistymisesi tällä selaimella?',
  'learn.savePrompt.body':
    'Se tallennetaan vain tähän selaimeen eikä sitä lähetetä meille. Voit poistaa sen milloin tahansa kohdassa ”Omat tiedot”.',
  'learn.savePrompt.yes': 'Kyllä, tallenna',
  'learn.savePrompt.no': 'Ei kiitos',
  'learn.saving': 'Tallennetaan tälle selaimelle…',
  'learn.saved': 'Edistymisesi on tallennettu vain tälle selaimelle.',
  'learn.notSaved':
    'Edistymisesi säilyy vain siihen asti, kunnes suljet tai lataat sivun uudelleen.',
  'learn.start.title': 'Mistä haluaisit aloittaa?',
  'learn.start.beginning': 'Alusta',
  'learn.start.harder': 'Olen tehnyt virtapiirejä ennenkin',
  'learn.start.note': 'Voit aina valita toisen tehtävän.',
  'learn.progress.title': 'Mitä olet harjoitellut',
  'learn.progress.none': 'Mitään ei ole vielä kokeiltu. Edistymisesi näkyy tässä.',
  'learn.progress.about':
    'Ei vielä kokeiltu → Alussa → Harjoiteltu → Näytetty itse. ”Näytetty itse” tarkoittaa, että ratkaisit vaikeamman tehtävän enintään yhdellä vihjeellä ja kolmella testillä.',
  'learn.ev.solved': '”{challenge}”: ratkaistu · testejä: {tests} · vihjeitä: {hints} · {date}',
  'learn.ev.notYet': '”{challenge}”: ei vielä ratkaistu · testejä: {tests} · {date}',
  'learn.provisional.one': 'Ensimmäinen arvio {count} tehtävän perusteella, ei arvosana.',
  'learn.provisional.other': 'Ensimmäinen arvio {count} tehtävän perusteella, ei arvosana.',
  'learn.continue': 'Jatka: {title}',
  'error.LEARN-EVIDENCE-001':
    'Edistymistäsi ei voitu tallentaa tälle selaimelle. Voit jatkaa pelaamista.',
  'ws.title': 'Tekijöiden pihan paja',
  'ws.toolbar': 'Pajan toiminnot',
  'ws.save': 'Tallenna',
  'ws.open': 'Avaa',
  'ws.undo': 'Kumoa',
  'ws.redo': 'Tee uudelleen',
  'ws.export': 'Vie',
  'ws.help': 'Ohje',
  'ws.isSaved': 'Tallennettu tälle selaimelle',
  'ws.unsaved': 'Ei vielä tallennettu',
  'ws.saving': 'Tallennetaan…',
  'ws.inventory': 'Osat',
  'ws.addHint':
    'Valitse osa lisätäksesi sen huoneeseen. Vedä sitä sitten tai liikuta nuolinäppäimillä.',
  'ws.cat.circuit': 'Virtapiirin osat',
  'ws.cat.decor': 'Huoneen tavarat',
  'ws.add': 'Lisää: {object}',
  'ws.added': '{object} lisätty.',
  'ws.removed': '{object} poistettu.',
  'ws.room': 'Pajan huone',
  'ws.view': '3D vai pohjapiirros',
  'ws.view3d': '3D',
  'ws.viewPlan': 'Pohjapiirros',
  'ws.snap': 'Kiinnitä ruudukkoon',
  'ws.loading3d': 'Rakennetaan pajaa…',
  'ws.zoomIn': 'Lähennä',
  'ws.zoomOut': 'Loitonna',
  'ws.resetCamera': 'Palauta näkymä',
  'ws.inspector': 'Ominaisuudet',
  'ws.objects': 'Huoneen tavarat',
  'ws.empty': 'Huone on tyhjä. Lisää osia vasemmalta listalta.',
  'ws.nothingSelected': 'Mitään ei ole valittu. Napsauta tavaraa huoneessa tai valitse se tästä:',
  'ws.position': 'Sijainti',
  'ws.x': 'Vasen–oikea (m)',
  'ws.y': 'Korkeus (m)',
  'ws.z': 'Edessä–takana (m)',
  'ws.rotateLeft': 'Käännä vasemmalle',
  'ws.rotateRight': 'Käännä oikealle',
  'ws.scale': 'Koko',
  'ws.colour': 'Väri',
  'ws.caption': 'Julisteen teksti',
  'ws.switch': 'Kytkin: {state}',
  'ws.threshold': 'Kytkeytyy päälle, kun valo on tätä tasoa heikompi',
  'ws.state': '{object}: {state}',
  'ws.wires': 'Johdot',
  'ws.connectTo': 'Yhdistä {port} …',
  'ws.connect': 'Yhdistä',
  'ws.removeWire': 'Poista johto {wire}',
  'ws.wireRemoved': 'Johto poistettu.',
  'ws.remove': 'Poista',
  'ws.duplicate': 'Kopioi',
  'ws.deselect': 'Valmis',
  'ws.portOf': '{object}, {end}',
  'ws.wireStart': 'Johto päästä {port}. Valitse nyt, mihin se menee.',
  'ws.wireDone': 'Johto yhdistetty: {from} – {to}.',
  'ws.wireCancel': 'Johto peruttu.',
  'ws.circuit.no-battery': 'Lisää paristo, jotta lamput ja tuulettimet toimivat.',
  'ws.circuit.several-batteries':
    'Tässä pajassa käytetään yhtä paristoa kerrallaan. Poista yksi paristo.',
  'ws.circuit.short': 'Oikosulku! Johto yhdistää + ja − ilman lamppua tai tuuletinta välissä.',
  'ws.circuit.ok': '{total} lampusta ja tuulettimesta toimii {on}.',
  'ws.keys':
    'Näppäimet: nuolet liikuta · R käännä (Shift+R takaisin) · D kopioi · Delete poista · Ctrl+Z kumoa · Ctrl+Y tee uudelleen · Esc lopeta',
  'ws.saveDialog': 'Tallenna projektisi',
  'ws.name': 'Nimi',
  'ws.saveHint': 'Se tallennetaan vain tähän selaimeen. Vie, jos haluat kopion tiedostona.',
  'ws.saved': '”{title}” on tallennettu.',
  'ws.cancel': 'Peruuta',
  'ws.close': 'Sulje',
  'ws.openDialog': 'Projektisi',
  'ws.newProject': 'Aloita jotain uutta',
  'ws.yourProjects': 'Tallennetut projektit',
  'ws.noProjects': 'Ei vielä tallennettuja projekteja.',
  'ws.updated': 'Päivitetty {date}',
  'ws.objectCount.one': '{count} tavara',
  'ws.objectCount.other': '{count} tavaraa',
  'ws.openProject': 'Avaa',
  'ws.openNamed': 'Avaa ”{title}”',
  'ws.exportNamed': 'Vie ”{title}”',
  'ws.deleteNamed': 'Poista ”{title}”',
  'ws.deleteProject': 'Poista',
  'ws.opened': '”{title}” on auki.',
  'ws.exported': 'Projektitiedostosi latautuu.',
  'ws.confirmDelete': 'Poistetaanko ”{title}”?',
  'ws.confirmDeleteBody':
    'Tämä poistaa sen tästä selaimesta. Vie se ensin, jos haluat säilyttää kopion.',
  'ws.continue': 'Jatka',
  'ws.discardTitle': 'Aloitetaanko tallentamatta?',
  'ws.unreadable': 'Yhtä tallennettua projektia ei voi avata',
  'ws.downloadRaw': 'Lataa se',
  'ws.import': 'Avaa projektitiedosto (.json)',
  'ws.leave': 'Poistutaanko tallentamatta?',
  'ws.leaveBody': 'Viimeisen tallennuksen jälkeiset muutokset menetetään.',
  'ws.stay': 'Jää',
  'ws.leaveConfirm': 'Poistu',
  'ws.helpTitle': 'Miten paja toimii',
  'ws.help1':
    'Lisää osia vasemmalta listalta. Napsauta tavaraa valitaksesi sen, vedä, käännä tai muuta sitä oikealla.',
  'ws.help2':
    'Johdota virtapiiri napsauttamalla yhden osan pyöreää päätä ja sitten toisen päätä. Lamppu palaa vain, kun silmukka on suljettu, aivan kuten labrassa.',
  'ws.help3':
    'Pohjapiirros näyttää huoneen ylhäältä ja toimii hyvin näppäimistöllä. Tallenna säilyttää projektin tässä selaimessa; Vie tekee tiedoston, jonka voit säilyttää.',
  'ws.storageUnavailable':
    'Tässä selaimessa ei voi tallentaa (yksityinen selaus tai estetty tallennus). Voit silti rakentaa ja viedä.',
  'ws.dismiss': 'Selvä',
  'ws.posterCaption': 'Lyhtyhuone',
  'ws.newTitle.empty': 'Oma huone',
  'ws.newTitle.lighthouse': 'Oma lyhtyhuone',
  'ws.starter.empty': 'Tyhjä huone',
  'ws.starter.lighthouse': 'Majakan lyhtyhuone',
  'ws.obj.floor-tile': 'Lattialaatta',
  'ws.obj.wall-panel': 'Seinäpaneeli',
  'ws.obj.table': 'Pöytä',
  'ws.obj.shelf': 'Hylly',
  'ws.obj.plant': 'Kasvi',
  'ws.obj.rug': 'Matto',
  'ws.obj.window': 'Ikkuna',
  'ws.obj.poster': 'Juliste',
  'ws.obj.battery': 'Paristo',
  'ws.obj.switch': 'Kytkin',
  'ws.obj.lamp': 'Lamppu',
  'ws.obj.light-sensor': 'Valoanturi',
  'ws.obj.fan': 'Tuuletin',
  'ws.port.positive': '+ -pää',
  'ws.port.negative': '− -pää',
  'ws.port.a': 'vasen pää',
  'ws.port.b': 'oikea pää',
  'ws.port.in': 'sisääntulo',
  'ws.port.out': 'ulostulo',
  'ws.colour.natural': 'Puu',
  'ws.colour.sky': 'Taivaansininen',
  'ws.colour.leaf': 'Lehdenvihreä',
  'ws.colour.sun': 'Auringonkeltainen',
  'ws.colour.berry': 'Marjanpunainen',
  'ws.colour.slate': 'Liuskeenharmaa',
  'ws.refused.too-many-objects': 'Huone on täynnä (300 tavaraa). Poista ensin jotain.',
  'ws.refused.too-many-wires': 'Johtoja on liikaa (300). Poista ensin yksi.',
  'ws.refused.same-port': 'Valitse eri pää.',
  'ws.refused.already-connected': 'Nuo kaksi päätä on jo yhdistetty.',
  'ws.refused.unknown-object': 'Tavaraa ei ole enää huoneessa.',
  'ws.refused.not-a-port': 'Se ei ole johdon pää.',
  'ws.refused.invalid': 'Tätä muutosta ei voi tehdä.',
  'error.WORLD-SAVE-001':
    'Tätä pajasi versiota ei voitu tallentaa. Viimeksi tallennettu versio on ennallaan — kokeile viedä projekti.',
  'error.WORLD-SAVE-002': 'Pajaasi ei voitu tallentaa. Kokeile ensin viedä projekti.',
  'error.WORLD-LOAD-001':
    'Tätä tallennettua projektia ei voitu avata. Se on säilytetty — voit ladata tai poistaa sen.',
  'error.WORLD-IMPORT-003':
    'Tämä tiedosto ei ole Kids World -projekti, jonka voisimme avata. Nykyiset projektisi ovat ennallaan.',
  'help.title': 'Ohje',
  'help.keyboardTitle': 'Näppäimistön käyttö',
  'help.keyboardBody':
    'Tab-näppäimellä siirryt painikkeesta toiseen ja Enterillä valitset. Ensimmäinen Tab-painallus tarjoaa vaihtoehdon ”Siirry sisältöön”. Escape sulkee avautuneen ikkunan.',
  'help.broadcasterTitle': 'Yleisradioyhtiö ja kieli',
  'help.broadcasterBody':
    'Valitse yhtiö nähdäksesi ohjelmat, jotka sen toimittajat ovat valinneet omaan maahansa. Jokaisella yhtiöllä on omat kielensä. Tallennetut projektisi säilyvät, kun vaihdat yhtiötä.',
  'help.fictionalTitle': 'Mitä ”kuvitteellinen” tarkoittaa',
  'help.fictionalBody':
    'Tämä on prototyyppi. Sen yhtiöt, ohjelmat ja henkilöt on keksitty testausta varten, eivätkä ne edusta todellisia organisaatioita tai lapsia.',
  'tree.sections': 'Puumajan osat',
  'tree.whose': 'Kenen asiat näytetään',
  'tree.storageUnavailable':
    'Tämä selain ei voi tallentaa mitään (yksityinen selaus tai estetty tallennus), joten täällä ei ole tallennettuja projekteja tai taitoja.',
  'tree.fictionalTag': 'Kuvitteellinen esimerkki',
  'tree.profile.sample-new-to-circuits': 'Esimerkkioppija: virtapiirit ovat uusia',
  'tree.profile.sample-experienced': 'Esimerkkioppija: kokenut virtapiireissä',
  'tree.profileBody.sample-new-to-circuits':
    'On kokeillut ensimmäistä virtapiiritehtävää paljon apua käyttäen ja aloittanut yhden huoneen pajassa.',
  'tree.profileBody.sample-experienced':
    'On ratkaissut vaikeampia suljetun piirin ja kytkimen tehtäviä ja rakentanut automaattisen yövalon.',
  'tree.sampleNote':
    'Katselet kuvitteellista esimerkkioppijaa, et oikeaa lasta. Se on kopio vain tässä selaimessa: mitä nyt teet, muuttaa vain tätä kopiota. Omat asiasi säilyvät.',
  'tree.backToOwn': 'Takaisin omiin',
  'tree.resetSample': 'Aloita tämä esimerkki alusta',
  'tree.removeSample': 'Poista tämä esimerkki',
  'tree.ownNote': 'Nämä ovat omia asioitasi, tallennettu vain tähän selaimeen.',
  'tree.trySample': 'Kokeile esimerkkioppijaa',
  'tree.trySampleBody':
    'Katso, miltä labra ja puumaja näyttävät kuvitteellisella oppijalla. Tähän selaimeen tehdään yksityinen kopio; kukaan muu ei näe sitä, ja omat asiasi pysyvät ennallaan.',
  'tree.useSample': 'Kokeile',
  'tree.openSample': 'Avaa uudelleen',
  'tree.useSampleNamed': 'Kokeile: {profile}',
  'tree.removeTitle': 'Poistetaanko tämä esimerkkioppija?',
  'tree.removeBody':
    'Sen kopio tässä selaimessa projekteineen ja edistymisineen poistetaan. Voit tehdä uuden kopion milloin tahansa.',
  'tree.loading': 'Ladataan…',
  'tree.projectsTitle': 'Tallennetut projektit',
  'tree.noProjects':
    'Mitään ei ole vielä tallennettu. Rakenna jotain tekijöiden pihalla ja tallenna se.',
  'tree.goBuild': 'Tekijöiden pihalle',
  'tree.projectsNote':
    'Projektit tallennetaan vain tähän selaimeen. Selaintietojen tyhjentäminen poistaa ne — käytä vientiä kopion tekemiseen.',
  'tree.skillsTitle': 'Virtapiirien ideat',
  'tree.skillsIntro':
    'Mitä labran tehtävät ovat tähän mennessä näyttäneet, idea kerrallaan. Jokainen rivi kertoo, mistä tehtävästä se tulee.',
  'tree.builtTitle': 'Virtapiirin osista rakennetut asiat',
  'tree.notAssessed': 'Ei arvioida',
  'tree.builtNone': 'Virtapiirin osia sisältäviä pajaprojekteja ei ole vielä tallennettu.',
  'tree.likesTitle': 'Mistä pidät',
  'tree.likesNone':
    'Kiinnostuksen kohteita ei ole tallennettu. Voit valita niitä elokuvateatterin haussa.',
  'tree.futureTag': 'Tulevaisuuden idea',
  'tree.futureCredential':
    'Todistukset ovat vain tulevaisuuden idea. Kids World ei anna todistuksia eikä arvosanoja.',
  'tree.reason.no-attempts': 'Tämän idean tehtävää ei ole vielä kokeiltu.',
  'tree.reason.tried-not-solved': '”{challenge}” ei ole vielä ratkaistu.',
  'tree.reason.solved-with-show-me':
    '”{challenge}” ratkaistiin ”näytä minulle” -avulla, joten tämä on alku.',
  'tree.reason.solved-entry': '”{challenge}” ratkaistiin.',
  'tree.reason.solved-harder-with-help':
    'Vaikeampi tehtävä ”{challenge}” ratkaistiin vähän apua käyttäen.',
  'tree.reason.solved-harder-independently': 'Vaikeampi tehtävä ”{challenge}” ratkaistiin itse.',
  'tree.ev.solved': '”{challenge}”: ratkaistu',
  'tree.ev.notYet': '”{challenge}”: ei vielä ratkaistu',
  'tree.ev.harder': 'vaikeampi taso',
  'tree.ev.entry': 'ensimmäinen taso',
  'tree.ev.tests': 'testit: {count}',
  'tree.ev.hints': 'vihjeet: {count}',
  'tree.ev.showMe': 'käytti ”näytä minulle”',
  'tree.ev.ownWay': 'itse',
  'tree.ev.chosen': 'oma valinta',
  'tree.byDay': 'Päivällä: {line}',
  'tree.atNight': 'Yöllä: {line}',
  'tree.sampleProject.firstRoom': 'Ensimmäinen huoneeni',
  'tree.sampleProject.nightLight': 'Yövalo',
  'shell.sampleActive': 'Kuvitteellinen esimerkki · {profile}',
  'shell.sampleBack': 'Takaisin omiin',
  'offer.title': '{broadcaster} ei tarjoa paikkaa {place}',
  'offer.body':
    'Jokainen yhtiö valitsee, mitä paikkoja se tarjoaa. Voit valita toisen yhtiön Euroopan maapallolla.',
  'offer.kept': 'Kaikki, mitä tallensit tähän selaimeen, säilyy.',
  'offer.globe': 'Euroopan maapallolle',
  'offer.town': 'Takaisin kaupunkiin',
  'hub.notOffered': 'Ei tarjolla täällä',
  'tree.samplesNotOffered': '{broadcaster} ei tarjoa esimerkkioppijoita.',
  'kids.readAloud': 'Lue minulle',
  'kids.who.title': 'Kuka pelaa?',
  'kids.little': 'Olen pieni',
  'kids.littleAges': '3–8',
  'kids.bigger': 'Olen isompi',
  'kids.biggerAges': '9+',
  'kids.who.say': 'Kuka pelaa? Kosketa pupua, jos olet pieni. Kosketa rakettia, jos olet isompi.',
  'kids.change': 'Vaihda pelaaja',
  'kids.town.say': 'Minne haluat mennä? Kosketa kuvaa.',
  'time.chipLabel': 'Ruutuaikaa jäljellä tänään {minutes} minuuttia',
  'time.chip': '{minutes} min jäljellä',
  'time.finish': 'Aika on loppu — tämä katsotaan loppuun',
  'rest.title': 'Lepoaika!',
  'rest.body': 'Tämän päivän ruutuaika on käytetty. Nähdään huomenna!',
  'grown.button': 'Aikuisille',
  'grown.title': 'Aikuisille',
  'grown.hold': 'Aikuiset: pidä painiketta painettuna 3 sekuntia.',
  'grown.holdButton': 'Pidä',
  'grown.noLimit': 'Ei rajaa',
  'grown.minutes': '{minutes} min',
  'grown.timeTitle': 'Ruutuaika tänään',
  'grown.timeIntro':
    'Kids World tarjoaa vain elokuvia, jotka mahtuvat jäljellä olevaan aikaan, eikä keskeytä yhtään kesken. Kun aika on käytetty, se sanoo hei elokuvan jälkeen.',
  'grown.used': 'Käytetty tänään: {minutes} min',
  'grown.settings': 'Yhtiö, kieli ja tiedot',
  'grown.save': 'Tallenna',
  'grown.close': 'Sulje',
  'room.hint.little': 'Kosketa kuvaa!',
  'room.hint.bigger': 'Valitse elokuva',
  'room.say': 'Olet elokuvateatterissa! Kosketa kuvaa katsoaksesi.',
  'room.soonSay': 'Tätä elokuvaa ei ole vielä täällä.',
  'room.laterSay': 'Tämä elokuva on liian pitkä tälle päivälle. Ensi kerralla!',
  'room.back': 'Takaisin kaupunkiin',
  'room.films': 'Elokuvat',
  'room.watch': 'Katso {title} ({minutes} min)',
  'room.laterLabel': '{title}: liian pitkä tälle päivälle',
  'room.soonLabel': '{title}: ei vielä täällä',
  'room.later': 'Ensi kerralla',
  'room.soon': 'Ei vielä',
  'room.minutes': '{minutes} min',
  'room.play': 'Toista',
  'room.pause': 'Tauko',
  'room.stop': 'Pysäytä elokuva',
  'room.details': 'Tietoa elokuvasta',
  'room.all': 'Kaikki elokuvat',
  'room.loading': 'Avataan elokuvateatteria…',
};
